
import { Component, Prop, Vue } from "vue-property-decorator";
import ChangeMovementActionBtn from "@/modules/Report/Movements/components/specialComponents/ChangeMovementActionBtn.vue";
import ActionsDropdown from "@/modules/Report/Movements/components/specialComponents/ActionsDropdown.vue";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import AppSwitch from "@/components/AppSwitch.vue";
import {isMobile} from "mobile-device-detect";
import {IAccounts} from "@/modules/Profile/interfaces/accounts.interface";

@Component({
  components: {
    AppSwitch,
    ChangeMovementActionBtn,
    ActionsDropdown,
  }
})
export default class ActiveCell extends Vue {
  @Prop() cell: IAppTable.ITableProp;
  @Prop() entity: IAccounts.IPerson;
  @Prop() index: number;

  async changeStatus(value) {
    if (value) await this.emitAction(value);
    else {
      await this.$store.dispatch('confirm/open', {
        title: 'Внимание',
        text: `Отправить пользователя ${isMobile ? this.entity.fio : this.entity.name} в архив?`,
        cancel: { text: 'Отменить', },
        confirm: {
          text: 'В архив',
          action: async () => {
            await this.emitAction(value);
          }
        },
      });
    }
  }

  async emitAction(value) {
    this.$emit('emitAction', {
      actionName: 'changeStatus',
      payload: {
        entity: this.entity,
        index: this.index,
        value,
      }
    });
  }

}
